import { render, staticRenderFns } from "./VehicleRDEventsTab.vue?vue&type=template&id=2ce4add2&"
import script from "./VehicleRDEventsTab.vue?vue&type=script&lang=js&"
export * from "./VehicleRDEventsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports